/* eslint-disable import/prefer-default-export */
import {
  CompletionStatus,
  States,
  StepKey,
} from 'redux/schemas/models/mentoring-program-enrollments';

export const noRequiredQuestions = (states: States) => (
  states[StepKey.PROFILE_COMPLETION]?.status === CompletionStatus.COMPLETED
  && states[StepKey.PROFILE_REVIEW]?.status === CompletionStatus.NOT_STARTED
);

// All required questions answered => PROFILE_COMPLETION status is COMPLETED and PROFILE_REVIEW status is IN_PROGRESS
// Otherwise => PROFILE_COMPLETION status is IN_PROGRESS and PROFILE_REVIEW status is NOT_STARTED
export const isAnyRequiredFieldUnanswered = (states: States) => (
  states[StepKey.PROFILE_COMPLETION]?.status !== CompletionStatus.COMPLETED
  && states[StepKey.PROFILE_REVIEW]?.status === CompletionStatus.NOT_STARTED
);

export const areAllRequiredFieldsAnswered = (states: States) => (
  states?.[StepKey.PROFILE_COMPLETION]?.status === CompletionStatus.COMPLETED
  && states[StepKey.PROFILE_REVIEW]?.status === CompletionStatus.IN_PROGRESS
);

export const notStarted = (states: States) => (
  states[StepKey.PROFILE_COMPLETION]?.status === CompletionStatus.NOT_STARTED
  && states[StepKey.PROFILE_REVIEW]?.status === CompletionStatus.NOT_STARTED
);

export const profileCompletionStarted = (states: States) => (
  states[StepKey.PROFILE_COMPLETION]?.status !== CompletionStatus.NOT_STARTED
);

const getProfileCompletionStatus = (states: States, currentStatus: CompletionStatus) => {
  // Set status to NOT_STARTED if profile review is not started and profile completion is completed
  if (currentStatus !== CompletionStatus.IN_PROGRESS &&
      states[StepKey.PROFILE_REVIEW]?.status === CompletionStatus.NOT_STARTED) {
    return CompletionStatus.NOT_STARTED;
  }
  return currentStatus;
};

const getWaitingFirstSessionStatus = (currentStatus: CompletionStatus, isSessionCreated?: boolean) => {
  return isSessionCreated ? currentStatus : CompletionStatus.NOT_STARTED;
};

const getFindAMentorStatus = (currentStatus: CompletionStatus, hasAMentor?: boolean, hasPendingMentorRequests?: boolean) => {
  if (hasAMentor) {
    return CompletionStatus.COMPLETED;
  }
  return hasPendingMentorRequests ? CompletionStatus.IN_PROGRESS : currentStatus;
};

const getReviewMenteeRequestsStatus = (currentStatus: CompletionStatus, hasAMentee?: boolean) => {
  if (hasAMentee) {
    return CompletionStatus.COMPLETED;
  }
  return currentStatus;
};

export const getStatus = (
  states: States,
  key: string,
  isSessionCreated?: boolean,
  hasAMentor?: boolean,
  hasPendingMentorRequests?: boolean,
  hasAMentee?: boolean,
): CompletionStatus => {
  const baseStatus = states[key]?.status || CompletionStatus.NOT_STARTED;

  switch (key) {
    case StepKey.PROFILE_COMPLETION:
      return getProfileCompletionStatus(states, baseStatus);

    case StepKey.WAITING_FIRST_SESSION:
      return getWaitingFirstSessionStatus(baseStatus, isSessionCreated);

    case StepKey.FIND_A_MENTOR:
      return getFindAMentorStatus(baseStatus, hasAMentor, hasPendingMentorRequests);

    case StepKey.REVIEW_MENTEE_REQUESTS:
      return getReviewMenteeRequestsStatus(baseStatus, hasAMentee);

    default:
      return baseStatus;
  }
};
